/* eslint-disable no-mixed-operators */
/* eslint-disable eqeqeq */
import React, { useRef } from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Tooltip from '@material-ui/core/Tooltip';
import { Info } from '@material-ui/icons';
import CardContent from '@material-ui/core/CardContent';
import Skeleton from 'react-loading-skeleton';
import { Image, Empty, TreeSelect, DatePicker } from "antd";
import moment from "moment";
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'
import { UploadOutlined } from '@ant-design/icons';
import { hasValue } from '../../validations/validations';
import PaginationButtons from '../../component/pagenation/pagenation';
const { TreeNode } = TreeSelect;

// Component for the image section (owner info and ad images)
export const ImageSection = ({ owner, advertisementImgs, isRTL, allStrings, history }) => (
    <div>
        {/* <div className="ownerInfoCard">
            <div style={{ height: '360px', overflow: 'hidden' }}>
                <div className="ownerImg">
                    <img alt="" src={owner.img ? owner.img : require('../../assets/images/profileicon.jpg')} />
                </div>
                <div className="ownerInfo">
                    <p className="pName">{owner.fullname ? owner.fullname : ""}</p>
                    <p className="pInfo">
                        <span className="material-icons infoIcon">location_city</span>
                        {owner.city ? owner.city.cityName : allStrings.notExist}
                    </p>
                    <p className="pInfo">
                        <span className="material-icons infoIcon">call</span>
                        {owner.phone ? owner.phone : allStrings.notExist}
                    </p>
                    <p className="pInfo">
                        <span className="material-icons infoIcon">email</span>
                        {owner.email ? owner.email : allStrings.notExist}
                    </p>
                    <p className="pInfo">
                        <span className="material-icons infoIcon">person_pin</span>
                        {owner.type === "ADMIN" ? allStrings.admin : owner.type === "OFFICE" ? allStrings.office : allStrings.client}
                    </p>
                </div>
                <div className="ownerInfoFooter">
                    <Button
                        style={{
                            background: 'linear-gradient(135deg, #1D9598, #127275)',
                            color: '#fff',
                            width: '90%',
                            margin: 'auto',
                            display: 'block'
                        }}
                        onClick={() => { history.push('/userInfo', { data: owner }) }}
                    >
                        {allStrings.viewInfo}
                    </Button>
                </div>
            </div>
        </div> */}
        <div className="infoCard" style={{ marginTop: '50px' }}>
            <div className="StoreSlider">
                <div style={{ height: '280px', overflow: 'hidden' }}>
                    <Image.PreviewGroup>
                        {advertisementImgs.map((val, i) =>
                            <Image
                                placeholder={true}
                                width="100%"
                                height="100%"
                                style={{ display: i === 0 ? "block" : "none", borderRadius: '6px' }}
                                src={val.original}
                                key={i}
                            />
                        )}
                    </Image.PreviewGroup>
                </div>
            </div>
        </div>
    </div>
);

// Component for the buttons section
export const ButtonsSection = ({ allStrings, history, state, toggleForUpdateStatus, toggleAddSeo, toggleForRegaData, toggleForDeal, toggleForCancelDeal, sendToRedf, deleteAd, marketAdvertisement, toggleMarket, currentUser, cancelDeal }) => (
    <div className="btnOption">
        <MDBRow>
            {(currentUser.user.type === "ADMIN" ||
                (currentUser.user.type === "SUB-ADMIN" && currentUser.user.managingProjects.includes(state.project)) ||
                (currentUser.user.type === "SUB-ADMIN" && currentUser.user.isEmployee)
            ) && (
                    <MDBCol md="4">
                        <MDBBtn
                            onClick={toggleForUpdateStatus}
                            color="primary"
                            style={{ background: 'linear-gradient(135deg, #4285F4, #3367D6)', color: '#fff' }}
                            rounded
                            className="btn-block z-depth-1a"
                        >
                            {allStrings.updateStatus}
                        </MDBBtn>
                    </MDBCol>
                )}
            {(state.deal && currentUser.user.type === "ADMIN" ||
                (state.deal && currentUser.user.type === "SUB-ADMIN" && currentUser.user.managingProjects.includes(state.project)) ||
                (state.deal && currentUser.user.type === "SUB-ADMIN" && currentUser.user.isEmployee)
            ) && (
                    <MDBCol md="4">
                        <MDBBtn
                            color="red"
                            onClick={toggleForCancelDeal}
                            style={{ borderRadius: "2px", background: 'red' }}
                            rounded
                            className="btn-block z-depth-1a"
                        >
                            {allStrings.cancelDeal}
                        </MDBBtn>
                    </MDBCol>
                )}
            <MDBCol md="4">
                <MDBBtn
                    onClick={toggleAddSeo}
                    color="primary"
                    style={{ background: 'linear-gradient(135deg, #4285F4, #3367D6)', color: '#fff' }}
                    rounded
                    className="btn-block z-depth-1a"
                >
                    <MDBIcon icon="plus" className="mr-2" />
                    {allStrings.addSeoDesc}
                </MDBBtn>
            </MDBCol>
            <MDBCol md="4">
                <MDBBtn
                    onClick={toggleForRegaData}
                    color="primary"
                    style={{ background: 'linear-gradient(135deg, #4285F4, #3367D6)', color: '#fff' }}
                    rounded
                    className="btn-block z-depth-1a"
                >
                    {allStrings.updateRegaData}
                </MDBBtn>
            </MDBCol>
            {/* {state.available && state.categoryType !== "PLANNED" && state.categoryType !== "VILLAS" && state.categoryType !== "BUILDING" && state.categoryType !== "OFF-PLAN-SALE" &&
                <MDBCol md="4">
                    <MDBBtn
                        onClick={toggleForDeal}
                        color="primary"
                        style={{ background: 'linear-gradient(135deg, #4285F4, #3367D6)', color: '#fff' }}
                        rounded
                        className="btn-block z-depth-1a"
                    >
                        {allStrings.makeDeal}
                    </MDBBtn>
                </MDBCol>
            } */}
            <MDBCol md="4">
                <MDBBtn
                    onClick={() => { history.push("views", { adveristment: state.id }) }}
                    rounded
                    className="btn-block z-depth-1a"
                >
                    {allStrings.views}
                </MDBBtn>
            </MDBCol>
            {!state.isInRedf &&
                <MDBCol md="4">
                    <MDBBtn
                        onClick={sendToRedf}
                        color="primary"
                        style={{ background: 'linear-gradient(135deg, #4285F4, #3367D6)', color: '#fff' }}
                        rounded
                        className="btn-block z-depth-1a"
                    >
                        {allStrings.sendToRedf}
                    </MDBBtn>
                </MDBCol>
            }
            <MDBCol md="4">
                <MDBBtn
                    color="red"
                    rounded
                    style={{ borderRadius: "2px", background: 'red' }}
                    className="btn-block z-depth-1a"
                    onClick={deleteAd}
                >
                    <MDBIcon icon="trash-alt" className="mr-2" />
                    {allStrings.remove}
                </MDBBtn>
            </MDBCol>
            {state.inMarket ?
                <MDBCol md="4">
                    <MDBBtn
                        rounded
                        color="warning"
                        style={{ borderRadius: "2px" }}
                        className="btn-block z-depth-1a"
                        onClick={() => { marketAdvertisement(false) }}
                    >
                        <MDBIcon icon="ban" className="mr-2" />
                        {allStrings.removeFromMarket}
                    </MDBBtn>
                </MDBCol>
                :
                <MDBCol md="4">
                    <MDBBtn
                        rounded
                        color="info"
                        style={{ borderRadius: "2px" }}
                        className="btn-block z-depth-1a"
                        onClick={toggleMarket}
                    >
                        <MDBIcon icon="check-circle" className="mr-2" />
                        {allStrings.addInMarket}
                    </MDBBtn>
                </MDBCol>
            }
        </MDBRow>
    </div>
);

// Component for the ad marketing table
export const AdMarketingTable = ({ allStrings, state, isRTL, history, getAdMarketing, setPage }) => {
    return (
        <MDBRow>
            <MDBCol md="12">
                <div className="infoTable">
                    <div className="topInfoTable" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}>
                        <h4>
                            {allStrings.marketInfo}
                        </h4>
                    </div>
                    <div className="tableDate">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    {isRTL ?
                                        <tr style={{ textAlign: 'center' }}>
                                            <th>{allStrings.more}</th>
                                            <th>{allStrings.commission}</th>
                                            <th>{allStrings.status}</th>
                                            <th>{allStrings.marketer}</th>
                                            <th scope="col">#</th>
                                        </tr>
                                        :
                                        <tr style={{ textAlign: 'center' }}>
                                            <th scope="col">#</th>
                                            <th>{allStrings.marketer}</th>
                                            <th>{allStrings.status}</th>
                                            <th>{allStrings.commission}</th>
                                            <th>{allStrings.more}</th>
                                        </tr>
                                    }
                                </thead>
                                <tbody>
                                    {state.loading ?
                                        <tr style={{ height: '200px' }}>
                                            <th colSpan="6" className="noData">
                                                <Skeleton height={400} />
                                            </th>
                                        </tr>
                                        :
                                        state.marketingAdInfo.length > 0 ?
                                            state.marketingAdInfo.map(val => (
                                                isRTL ?
                                                    <tr style={{ textAlign: 'center' }} key={val.id}>
                                                        <td>
                                                            <span
                                                                style={{ margin: "4px", cursor: 'pointer' }}
                                                                onClick={() => { history.push("marketingInfo", { data: val }) }}
                                                            >
                                                                <Tooltip title={allStrings.info} placement="top">
                                                                    <Info style={{ color: '#33d633' }} />
                                                                </Tooltip>
                                                            </span>
                                                        </td>
                                                        <td>{val.commission}</td>
                                                        <td>
                                                            {val.status === "ON-PROGRESS" ? allStrings.marketingOnProgress :
                                                                val.status === "WAITING-COMMISSION" ? allStrings.waitingCommission :
                                                                    val.status === "COMPLETED" ? allStrings.marketingComplete :
                                                                        allStrings.marketingFailed}
                                                        </td>
                                                        <td>{val.user.fullname}</td>
                                                        <td>{val.id}</td>
                                                    </tr>
                                                    :
                                                    <tr style={{ textAlign: 'center' }} key={val.id}>
                                                        <td>{val.id}</td>
                                                        <td>{val.user.fullname}</td>
                                                        <td>{val.commission}</td>
                                                        <td>
                                                            {val.status === "ON-PROGRESS" ? allStrings.marketingOnProgress :
                                                                val.status === "WAITING-COMMISSION" ? allStrings.waitingCommission :
                                                                    val.status === "COMPLETED" ? allStrings.marketingComplete :
                                                                        allStrings.marketingFailed}
                                                        </td>
                                                        <td>
                                                            <span
                                                                style={{ margin: "4px", cursor: 'pointer' }}
                                                                onClick={() => { history.push("marketingInfo", { data: val }) }}
                                                            >
                                                                <Tooltip title={allStrings.info} placement="top">
                                                                    <Info style={{ color: '#33d633' }} />
                                                                </Tooltip>
                                                            </span>
                                                        </td>
                                                    </tr>
                                            ))
                                            :
                                            <tr style={{ height: '200px' }}>
                                                <th colSpan="6" className="noData">
                                                    <Empty description={allStrings.noData} style={{ margin: '0rem' }} />
                                                </th>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                            {state.marketingAdInfo.length > 0 &&
                                <div style={{ textAlign: 'center', margin: 'auto', marginTop: '3rem' }}>
                                    <PaginationButtons
                                        page={state.page}
                                        pages={state.pages}
                                        labels={allStrings}
                                        onPageChange={(newPage) => {
                                            getAdMarketing(newPage, state.id);
                                            setPage(newPage);
                                        }}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </MDBCol>
        </MDBRow>
    );
};



export const ModalForMarket = ({ isOpen, toggleMarket, submitHandlerAddInMarket, changeHandler, isRTL, allStrings }) => (
    <MDBModal isOpen={isOpen} toggle={toggleMarket} size="lg">
        <MDBModalHeader toggle={toggleMarket}>{allStrings.completeData}</MDBModalHeader>
        <MDBModalBody>
            <MDBContainer>
                <MDBRow>
                    <MDBCol md="12">
                        <form style={{ paddingTop: '1rem' }}
                            className="needs-validation"
                            onSubmit={submitHandlerAddInMarket}
                            noValidate
                        >
                            <div className="grey-text">
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="form920" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.commission}</label>
                                            <br></br>
                                            <input name="commissionCost" onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={0} id="form920" className="form-control" validate required placeholder="أدخل الرقم..." />
                                            <div className="valid-feedback">{allStrings.correct}</div>
                                            <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                            <div className="drawer-action-footer">
                                <MDBBtn type="submit" className="btn-submit">
                                    {allStrings.add}
                                </MDBBtn>
                                <MDBBtn type="button" className="btn-cancel" onClick={toggleMarket}>
                                    إلغاء
                                </MDBBtn>
                            </div>
                        </form>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBModalBody>
    </MDBModal>
);

export const ModalForSeo = ({ isOpen, toggleAddSeo, submitHandlerAddSeoDesc, changeHandler, handleTagsChange, state, isRTL, allStrings }) => (
    <MDBModal isOpen={isOpen} toggle={toggleAddSeo} size="lg">
        <MDBModalHeader toggle={toggleAddSeo}>{allStrings.completeData}</MDBModalHeader>
        <MDBModalBody>
            <MDBContainer>
                <MDBRow>
                    <MDBCol md="12">
                        <form style={{ paddingTop: '1rem' }}
                            className="needs-validation"
                            onSubmit={submitHandlerAddSeoDesc}
                            noValidate
                        >
                            <div className="grey-text">
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="seoDescription_en" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishDescription}</label>
                                            <br></br>
                                            <textarea onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$؟'"?#*&()_^&!\\/\s-_]/g, '')} name="seoDescription_en" value={state.seoDescription_en} onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="seoDescription_en" className="form-control" validate required placeholder="أدخل وصف SEO بالانجليزية..." />
                                            <div className="valid-feedback">{allStrings.correct}</div>
                                            <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="seoDescription_ar" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicDescription}</label>
                                            <br></br>
                                            <textarea onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9\u0660-\u0669#.,@?؟%$_^*()/\\ _-]+/g, '')} name="seoDescription_ar" value={state.seoDescription_ar} onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="seoDescription_ar" className="form-control" validate required placeholder="أدخل وصف SEO بالعربية..." />
                                            <div className="valid-feedback">{allStrings.correct}</div>
                                            <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="seoTitle_en" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishTitle}</label>
                                            <br></br>
                                            <textarea placeholder="أدخل وصف SEO بالعربية..." onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$؟'"?#*&()_^&!\\/\s-_]/g, '')} name="seoTitle_en" value={state.seoTitle_en} onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="seoTitle_en" className="form-control" validate required />
                                            <div className="valid-feedback">{allStrings.correct}</div>
                                            <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="seoTitle_ar" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicTitle}</label>
                                            <br></br>
                                            <textarea onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9\u0660-\u0669#.,@?؟%$_^*()/\\ _-]+/g, '')} name="seoTitle_ar" value={state.seoTitle_ar} onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="seoTitle_ar" className="form-control" validate required placeholder="أدخل عنوان SEO بالعربية..." />
                                            <div className="valid-feedback">{allStrings.correct}</div>
                                            <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="bestFeature_en" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishBestFeatures}</label>
                                            <br></br>
                                            <textarea placeholder="أدخل عنوان SEO بالعربية..." onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$؟'"?#*&()_^&!\\/\s-_]/g, '')} name="bestFeature_en" value={state.bestFeature_en} onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="bestFeature_en" className="form-control" validate required />
                                            <div className="valid-feedback">{allStrings.correct}</div>
                                            <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="bestFeature_ar" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicBestFeatures}</label>
                                            <br></br>
                                            <textarea onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9\u0660-\u0669#.,@?؟%$_^*()/\\ _-]+/g, '')} name="bestFeature_ar" value={state.bestFeature_ar} onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="bestFeature_ar" className="form-control" validate required placeholder="أدخل أفضل ميزة بالعربية..." />
                                            <div className="valid-feedback">{allStrings.correct}</div>
                                            <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="form920" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.seoTags}</label>
                                            <br></br>
                                            <TagsInput value={state.seoTags} onChange={handleTagsChange} />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                            <div className="drawer-action-footer">
                                <MDBBtn type="submit" className="btn-submit">
                                    {allStrings.send}
                                </MDBBtn>
                                <MDBBtn type="button" className="btn-cancel" onClick={toggleAddSeo}>
                                    إلغاء
                                </MDBBtn>
                            </div>
                        </form>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBModalBody>
    </MDBModal>
);

export const ModalForDeal = ({ isOpen, toggleForDeal, submitHandlerDeal, changeHandler, fileChangedHandlerContractFile, fileChangedHandlerRecieptFile, removeContractFile, removeRecieptFile, state, isRTL, allStrings }) => (
    <MDBModal isOpen={isOpen} toggle={toggleForDeal} size="lg">
        <MDBModalHeader toggle={toggleForDeal}>{allStrings.completeData}</MDBModalHeader>
        <MDBModalBody>
            <MDBContainer>
                <MDBRow>
                    <MDBCol md="12">
                        <form style={{ paddingTop: '1rem' }}
                            className="needs-validation"
                            onSubmit={submitHandlerDeal}
                            noValidate
                        >
                            <div className="grey-text">
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="client" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.client}</label>
                                            <br></br>
                                            <input name="client" onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={0} id="client" className="form-control" validate required placeholder="أدخل الرقم..." />
                                            <div className="valid-feedback">{allStrings.correct}</div>
                                            <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="fileUpload2">
                                            <input key={state.contractFile} type='file' className="upImgs2" onChange={fileChangedHandlerContractFile}></input>
                                            <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.contractFile}</span></span>
                                        </div>
                                        <div className="preview">
                                            {state.contractFile &&
                                                <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                    <img alt="" src={URL.createObjectURL(state.contractFile)} className="previewImg2" />
                                                    <span className="imgName">{state.contractFileName}</span>
                                                    <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                        onClick={removeContractFile}></MDBIcon>
                                                </div>
                                            }
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="fileUpload2">
                                            <input key={state.recieptFile} type='file' className="upImgs2" onChange={fileChangedHandlerRecieptFile}></input>
                                            <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.recieptFile}</span></span>
                                        </div>
                                        <div className="preview">
                                            {state.recieptFile &&
                                                <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                    <img alt="" src={URL.createObjectURL(state.recieptFile)} className="previewImg2" />
                                                    <span className="imgName">{state.recieptFileName}</span>
                                                    <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                        onClick={removeRecieptFile}></MDBIcon>
                                                </div>
                                            }
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                            <div className="drawer-action-footer">
                                <MDBBtn type="submit" className="btn-submit">
                                    {allStrings.add}
                                </MDBBtn>
                                <MDBBtn type="button" className="btn-cancel" onClick={toggleForDeal}>
                                    إلغاء
                                </MDBBtn>
                            </div>
                        </form>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBModalBody>
    </MDBModal>
);

export const ModalForRegaData = ({ isOpen, toggleForRegaData, submitHandleUpdateRegaData, changeHandler, state, isRTL, allStrings }) => (
    <MDBModal isOpen={isOpen} toggle={toggleForRegaData} size="lg">
        <MDBModalHeader toggle={toggleForRegaData}>{allStrings.completeData}</MDBModalHeader>
        <MDBModalBody>
            <MDBContainer>
                <MDBRow>
                    <MDBCol md="12">
                        <form style={{ paddingTop: '1rem' }}
                            className="needs-validation"
                            onSubmit={submitHandleUpdateRegaData}
                            noValidate
                        >
                            <div className="grey-text">
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="adNumber" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>
                                                {allStrings.adNumber} <span style={{ color: '#ef4444' }}>*</span>
                                            </label>
                                            <input style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" value={state.adNumber} onChange={changeHandler} id="adNumber" name="adNumber" className="form-control" required placeholder="أدخل البيانات..." />
                                            <div className="valid-feedback">{allStrings.correct}</div>
                                            <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                            <div className="drawer-action-footer">
                                <MDBBtn type="submit" className="btn-submit">
                                    {allStrings.send}
                                </MDBBtn>
                                <MDBBtn type="button" className="btn-cancel" onClick={toggleForRegaData}>
                                    إلغاء
                                </MDBBtn>
                            </div>
                        </form>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBModalBody>
    </MDBModal>
);



export const ModalForUpdateStatus = ({ currentUser, isOpen, toggleForUpdateStatus, submitHandleUpdateStatus, changeHandler, fileChangedHandlerRecieptFile, removeRecieptFile, searchForReleatedEmployee, state, isRTL, allStrings, handleChangeState, fileChangedHandlerDepositRefundReciept, removeDepositRefundReciept }) => (
    <MDBModal isOpen={isOpen} toggle={toggleForUpdateStatus} size="lg">
        <MDBModalHeader toggle={toggleForUpdateStatus}>{allStrings.completeData}</MDBModalHeader>
        <MDBModalBody>
            <MDBContainer>
                <MDBRow>
                    <MDBCol md="12">
                        <form style={{ paddingTop: '1rem' }}
                            className="needs-validation"
                            onSubmit={submitHandleUpdateStatus}
                            noValidate
                        >
                            <div className="grey-text">
                                <MDBRow>
                                    <MDBCol md="12">
                                        <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status} <span style={{ color: '#ef4444' }}>*</span></label>
                                        <TreeSelect virtual={false}
                                            showSearch={true}
                                            value={state.updateStatus}
                                            style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                            treeCheckable={false}
                                            treeNodeFilterProp="title"
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            placeholder={allStrings.status}
                                            onChange={(value) => {
                                                console.log(value)
                                                handleChangeState('updateStatus', value)
                                            }}
                                        >
                                            <TreeNode value="BOOKED" title={allStrings.booked} key="BOOKED" disabled={!['COMPLETED', 'DELIVERED', 'SOLD', 'BOOKED'].includes(state.status) ? false : true} />
                                            <TreeNode value="BOOKED-WITHOUT-PAY" title={allStrings.bookedWithoutPay} key="BOOKED-WITHOUT-PAY" disabled={state.available ? false : true} />
                                            <TreeNode value="SOLD" title={allStrings.sold} key="SOLD" disabled={!['COMPLETED', 'DELIVERED', 'SOLD'].includes(state.status) ? false : true} />
                                            <TreeNode value="COMPLETED" title={allStrings.completedUnit} key="COMPLETED" disabled={state.status === "SOLD" ? false : true} />
                                            {(state.deal && currentUser.user.type === "ADMIN" ||
                                                (state.deal && currentUser.user.type === "SUB-ADMIN" && currentUser.user.permission.pages.includes('REFUND-DEPOSITS'))) && (
                                                    <TreeNode value="DELIVERED" title={allStrings.deliverd} key="DELIVERED" disabled={state.status === "COMPLETED" ? false : true} />
                                                )}
                                            <TreeNode value="AVAILABLE" title={allStrings.available} key="AVAILABLE" disabled={state.status === "BOOKED-WITHOUT-PAY" ? false : true} />
                                        </TreeSelect>
                                    </MDBCol>
                                </MDBRow>
                                {['BOOKED', 'SOLD'].includes(state.updateStatus) && !state.deal &&
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="clientName" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientName} <span style={{ color: '#ef4444' }}>*</span></label>
                                                <input name="clientName" onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="clientName" className="form-control" validate required placeholder="أدخل البيانات..." />
                                                <div className="valid-feedback">{allStrings.correct}</div>
                                                <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="clientPhone" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientPhone} <span style={{ color: '#ef4444' }}>*</span></label>
                                                <input name="clientPhone" onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="clientPhone" className="form-control" validate required placeholder="أدخل البيانات..." />
                                                <div className="valid-feedback">{allStrings.correct}</div>
                                                <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                }
                                {['BOOKED', 'SOLD'].includes(state.updateStatus) && !state.deal &&
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientType} <span style={{ color: '#ef4444' }}>*</span></label>
                                            <TreeSelect virtual={false}
                                                showSearch={true}
                                                value={state.clientType}
                                                style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                treeCheckable={false}
                                                treeNodeFilterProp="title"
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.clientType}
                                                onChange={(value) => {
                                                    console.log(value)
                                                    handleChangeState('clientType', value)
                                                }}

                                            >
                                                <TreeNode value="RENT" title={allStrings.rent} key="RENT" />
                                                <TreeNode value="HOUSING" title={allStrings.housing} key="HOUSING" />
                                                <TreeNode value="INVESTMENT" title={allStrings.investment} key="INVESTMENT" />
                                                <TreeNode value="OFF-PLAN-SALE" title={allStrings.offPlanSale} key="OFF-PLAN-SALE" />


                                            </TreeSelect>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientCountry} <span style={{ color: '#ef4444' }}>*</span></label>
                                            <TreeSelect virtual={false}
                                                showSearch={true}
                                                style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                treeCheckable={false}
                                                treeNodeFilterProp="title"
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.country}
                                                onChange={(value) => {
                                                    console.log(value)
                                                    handleChangeState('clientCountry', value)
                                                }}

                                            >
                                                {state.countries.map(val => (
                                                    <TreeNode value={val.id} title={isRTL ? val.countryName_ar : val.countryName_en} key={val.id} />
                                                ))}
                                            </TreeSelect>
                                        </MDBCol>
                                    </MDBRow>
                                }
                                {['BOOKED', 'SOLD'].includes(state.updateStatus) && !state.deal &&
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="clientIdNumber" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.cardNum} <span style={{ color: '#ef4444' }}>*</span></label>
                                                <input name="clientIdNumber" onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="clientIdNumber" className="form-control" validate required placeholder="أدخل البيانات..." />
                                                <div className="valid-feedback">{allStrings.correct}</div>
                                                <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.birthday}</label>
                                            <DatePicker
                                                dropdownAlign={{ points: ['bl', 'tl'] }}
                                                placement="topLeft"
                                                showTime={{ use12Hours: true, format: 'h:mm A' }}
                                                style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', marginBottom: '1rem' }}
                                                onChange={(date, dateString) => {
                                                    console.log(dateString)
                                                    handleChangeState('clientBirthday', dateString)
                                                }}
                                                placeholder={allStrings.birthday}
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                }
                                {['BOOKED', 'SOLD'].includes(state.updateStatus) && !state.deal &&
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="discount" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.discount} <span style={{ color: '#ef4444' }}>*</span></label>
                                                <input name="discount" onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={0} id="discount" value={state.discount} className="form-control" validate placeholder="أدخل الرقم..." />
                                                <div className="valid-feedback">{allStrings.correct}</div>
                                                <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="deposit" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.deposit} <span style={{ color: '#ef4444' }}>*</span></label>
                                                <input name="deposit" onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={0} id="deposit" value={state.deposit} className="form-control" validate required placeholder="أدخل مبلغ العربون..." />
                                                <div className="valid-feedback">{allStrings.correct}</div>
                                                <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>

                                    </MDBRow>
                                }
                                {['BOOKED', 'SOLD'].includes(state.updateStatus) && !state.deal &&
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.soldBy} <span style={{ color: '#ef4444' }}>*</span></label>
                                            <TreeSelect virtual={false}
                                                showSearch={true}
                                                value={state.soldBy}
                                                style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                treeCheckable={false}
                                                treeNodeFilterProp="title"
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.soldBy}
                                                onChange={(value) => {
                                                    console.log(value)
                                                    handleChangeState('soldBy', value)
                                                }}
                                            >
                                                <TreeNode value="SAAEI" title='ساعي' key="SAAEI" />
                                                <TreeNode value="DEVELOPER" title='المطور' key="DEVELOPER" />
                                            </TreeSelect>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.depositPayType} <span style={{ color: '#ef4444' }}>*</span></label>
                                            <TreeSelect virtual={false}
                                                showSearch={true}
                                                value={state.depositPayType}
                                                style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                treeCheckable={false}
                                                treeNodeFilterProp="title"
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.depositPayType}
                                                onChange={(value) => {
                                                    console.log(value)
                                                    handleChangeState('depositPayType', value)
                                                }}
                                            >
                                                <TreeNode value="SAAEI" title='ساعي' key="SAAEI" />
                                                <TreeNode value="DEVELOPER" title='المطور' key="DEVELOPER" />
                                            </TreeSelect>
                                        </MDBCol>
                                    </MDBRow>
                                }

                                <MDBRow>
                                    {['BOOKED', 'SOLD'].includes(state.updateStatus) && !state.deal &&
                                        <MDBCol md="6" sm="6">
                                            <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.project} <span style={{ color: '#ef4444' }}>*</span></label>
                                            <TreeSelect virtual={false}
                                                showSearch={true}
                                                style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                treeCheckable={false}
                                                treeNodeFilterProp="title"
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.project}
                                                value={state.project}
                                                onChange={(value) => {
                                                    console.log(value)
                                                    handleChangeState('project', value)
                                                    if (hasValue(state.clientPhone)) {
                                                        searchForReleatedEmployee(state.clientPhone, value)
                                                    }
                                                }}
                                            >
                                                {Array.isArray(state.projects) && state.projects.map(val => (
                                                    <TreeNode value={val.id} title={isRTL ? val.name_ar : val.name_en} key={val.id} />
                                                ))}
                                            </TreeSelect>
                                        </MDBCol>
                                    }
                                    {['BOOKED', 'SOLD'].includes(state.updateStatus) && !state.deal &&
                                        <MDBCol md="6">
                                            <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.employee} <span style={{ color: '#ef4444' }}>*</span></label>
                                            <TreeSelect virtual={false}
                                                showSearch={true}
                                                style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                treeCheckable={true}
                                                treeNodeFilterProp="title"
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.employee}
                                                value={state.employee}
                                                onChange={(value) => {
                                                    console.log(value)
                                                    handleChangeState('employee', value)
                                                }}
                                            >
                                                {Array.isArray(state.users) && state.users.map(val => (
                                                    <TreeNode value={val.id} title={val.fullname} key={val.id} />
                                                ))}
                                            </TreeSelect>
                                        </MDBCol>
                                    }
                                </MDBRow>
                                <MDBRow>

                                    {['BOOKED', 'SOLD'].includes(state.updateStatus) &&
                                        <MDBCol md="6">
                                            <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.paymentType} <span style={{ color: '#ef4444' }}>*</span></label>
                                            <TreeSelect virtual={false}
                                                showSearch={true}
                                                value={state.paymentType}
                                                style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                treeCheckable={false}
                                                treeNodeFilterProp="title"
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.paymentType}
                                                onChange={(value) => {
                                                    console.log(value)
                                                    handleChangeState('paymentType', value)
                                                }}
                                            >
                                                <TreeNode value="ONLINE" title={allStrings.online} key="ONLINE" />
                                                <TreeNode value="CASH" title={allStrings.cash} key="CASH" />
                                                <TreeNode value="BANK" title={allStrings.bank} key="BANK" />
                                            </TreeSelect>
                                        </MDBCol>
                                    }
                                    {['BOOKED'].includes(state.updateStatus) &&
                                        <MDBCol md="6"></MDBCol>
                                    }
                                    {['SOLD'].includes(state.updateStatus) &&
                                        <MDBCol md="6">
                                            <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.deliveredDate} <span style={{ color: '#ef4444' }}>*</span></label>
                                            <DatePicker
                                                dropdownAlign={{ points: ['bl', 'tl'] }}
                                                placement="topLeft"
                                                showTime={{ use12Hours: true, format: 'h:mm A' }}
                                                style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', marginBottom: '1rem' }}
                                                onChange={(date, dateString) => {
                                                    console.log(dateString)
                                                    handleChangeState('deliveredDate', dateString)
                                                }}
                                                placeholder={allStrings.completedDate}
                                            />
                                        </MDBCol>
                                    }

                                </MDBRow>
                                {['COMPLETED'].includes(state.updateStatus) &&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.deliveredDate} <span style={{ color: '#ef4444' }}>*</span></label>
                                            <DatePicker
                                                dropdownAlign={{ points: ['bl', 'tl'] }}
                                                placement="topLeft"
                                                showTime={{ use12Hours: true, format: 'h:mm A' }}
                                                style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', marginBottom: '1rem' }}
                                                onChange={(date, dateString) => {
                                                    console.log(dateString)
                                                    handleChangeState('deliveredDate', dateString)
                                                }}
                                                placeholder={allStrings.completedDate}
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                }
                                {['BOOKED', 'SOLD'].includes(state.updateStatus) && !state.deal &&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="fileUpload2">
                                                <input key={state.recieptFile} type='file' className="upImgs2" onChange={fileChangedHandlerRecieptFile}></input>
                                                <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.recieptFile}</span></span>
                                            </div>
                                            <div className="preview">
                                                {state.recieptFile &&
                                                    <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                        <img alt="" src={URL.createObjectURL(state.recieptFile)} className="previewImg2" />
                                                        <span className="imgName">{state.recieptFileName}</span>
                                                        <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                            onClick={removeRecieptFile}></MDBIcon>
                                                    </div>
                                                }
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                }
                                {['COMPLETED'].includes(state.updateStatus) &&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="fileUpload2">
                                                <input key={state.depositRefundReciept} type='file' className="upImgs2" onChange={fileChangedHandlerDepositRefundReciept}></input>
                                                <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.depositRefundReciept}</span></span>
                                            </div>
                                            <div className="preview">
                                                {state.depositRefundReciept &&
                                                    <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                        <img alt="" src={URL.createObjectURL(state.depositRefundReciept)} className="previewImg2" />
                                                        <span className="imgName">{state.depositRefundRecieptName}</span>
                                                        <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                            onClick={removeDepositRefundReciept}></MDBIcon>
                                                    </div>
                                                }
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                }

                            </div>
                            <div className="drawer-action-footer">
                                <MDBBtn type="submit" className="btn-submit">
                                    {allStrings.send}
                                </MDBBtn>
                                <MDBBtn type="button" className="btn-cancel" onClick={toggleForUpdateStatus}>
                                    إلغاء
                                </MDBBtn>
                            </div>
                        </form>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBModalBody>
    </MDBModal>
);
export const ModalForCancelDeal = ({ isOpen, toggleForCancelDeal, submitHandlerCancelDeal, changeHandler, handleChangeState, fileChangedHandlerDepositRefundReciept, removeDepositRefundReciept, state, isRTL, allStrings }) => (
    <MDBModal isOpen={isOpen} toggle={toggleForCancelDeal} size="lg">
        <MDBModalHeader toggle={toggleForCancelDeal}>{allStrings.completeData}</MDBModalHeader>
        <MDBModalBody>
            <MDBContainer>
                <MDBRow>
                    <MDBCol md="12">
                        <form style={{ paddingTop: '1rem' }}
                            className="needs-validation"
                            onSubmit={submitHandlerCancelDeal}
                            noValidate
                        >
                            <div className="grey-text">
                                <MDBRow>
                                    <MDBCol md="12">
                                        <label className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.refundType} <span style={{ color: '#ef4444' }}>*</span></label>
                                        <TreeSelect virtual={false}
                                            showSearch={true}
                                            value={state.refundType}
                                            style={{ width: '100%', textAlign: isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                            treeCheckable={false}
                                            treeNodeFilterProp="title"
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            placeholder={allStrings.refundType}
                                            onChange={(value) => {
                                                console.log(value)
                                                handleChangeState('refundType', value)
                                            }}
                                        >
                                            <TreeNode value="NOT-ACCEPTED-FUND" title={allStrings.notAcceptedFund} key="NOT-ACCEPTED-FUND" />
                                            <TreeNode value="OTHER" title={allStrings.other} key="OTHER" />
                                        </TreeSelect>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="clientName" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.reason} <span style={{ color: '#ef4444' }}>*</span></label>
                                            <input name="reason" onChange={changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="reason" className="form-control" validate required placeholder="أدخل السبب..." />
                                            <div className="valid-feedback">{allStrings.correct}</div>
                                            <div className="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div className="fileUpload2">
                                            <input key={state.depositRefundReciept} type='file' className="upImgs2" onChange={fileChangedHandlerDepositRefundReciept}></input>
                                            <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.depositRefundReciept}</span></span>
                                        </div>
                                        <div className="preview">
                                            {state.depositRefundReciept &&
                                                <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                    <img alt="" src={URL.createObjectURL(state.depositRefundReciept)} className="previewImg2" />
                                                    <span className="imgName">{state.depositRefundRecieptName}</span>
                                                    <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                        onClick={removeDepositRefundReciept}></MDBIcon>
                                                </div>
                                            }
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </div>
                            <div className="drawer-action-footer">
                                <MDBBtn type="submit" className="btn-submit">
                                    {allStrings.send}
                                </MDBBtn>
                                <MDBBtn type="button" className="btn-cancel" onClick={toggleForCancelDeal}>
                                    إلغاء
                                </MDBBtn>
                            </div>
                        </form>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBModalBody>
    </MDBModal>
);
// Component for the main card content (ad details)
export const MainCardContent = ({ state, isRTL, allStrings, history, setNewData }) => {
    const inputRef = useRef(null);
    const copyText = () => {
        if (inputRef.current) {
            inputRef.current.select();
            navigator.clipboard.writeText(inputRef.current.value);
        }
    };
    return (
        <CardContent style={{ minHeight: "390px", outline: 'none' }}>
            <MDBContainer>
                <span
                    className="material-icons"
                    onClick={copyText}
                    style={{ cursor: 'pointer', color: state.copyColor }}
                >
                    content_copy
                </span>
                <input
                    ref={inputRef}
                    type="text"
                    defaultValue={"https://saaei.co/realty-management/view-realty-advertisement/" + state.id}
                    style={{ position: 'fixed', top: '-1000px' }}
                    placeholder="أدخل البيانات..." />
                <MDBRow>
                    <MDBCol md="12">
                        <form
                            className="needs-validation"
                            noValidate
                        >
                            <div className="grey-text">
                                <MDBRow>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form635" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.status == "BOOKED" ? allStrings.booked : state.status == "SOLD" ? allStrings.sold : state.status == "COMPLETED" ? allStrings.completedUnit : state.status == "BOOKED-WITHOUT-PAY" ? allStrings.bookedWithoutPay : state.status == "DELIVERED" ? allStrings.deliverd : allStrings.available} type="text" id="form635" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form605" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.id} type="text" id="form605" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form635" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.inMarket}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.inMarket ? allStrings.yes : allStrings.no} type="text" id="form635" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form605" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.commission}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.commissionCost} type="text" id="form605" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form655" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishTitle}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.title_en} type="text" id="form655" name="title_en" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form56" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicTitle}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.title_ar} type="text" id="form56" name="title_ar" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form6005" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.available}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.available ? allStrings.yes : allStrings.no} type="text" id="form6005" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form6095" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.contractType}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.contractType === "SALE" ? allStrings.sale : allStrings.rent} type="text" id="form6095" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div class="md-form">
                                            <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishDescription}</label>
                                            <br></br>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            <textarea disabled style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} value={state.description_en} type="text" id="form645" name="description_en" class="form-control" />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div class="md-form">
                                            <label htmlFor="form56" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicDescription}</label>
                                            <br></br>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            <textarea disabled style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} value={state.description_ar} type="text" id="form56" name="description_ar" class="form-control" />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div class="md-form">
                                            <label htmlFor="form65" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishSeoDescription}</label>
                                            <br></br>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            <textarea disabled style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} value={state.seoDescription_en !== "" ? state.seoDescription_en : allStrings.notExist} type="text" id="form645" name="description_en" class="form-control" />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div class="md-form">
                                            <label htmlFor="form56" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicSeoDescription}</label>
                                            <br></br>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            <textarea disabled style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} value={state.seoDescription_ar !== "" ? state.seoDescription_ar : allStrings.notExist} type="text" id="form56" name="description_ar" class="form-control" />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div class="md-form">
                                            <label htmlFor="form05" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishBestFeatures}</label>
                                            <br></br>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            <textarea disabled style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} value={state.bestFeature_en} type="text" id="form05" name="bestFeature_en" class="form-control" />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div class="md-form">
                                            <label htmlFor="form36" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicBestFeatures}</label>
                                            <br></br>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            <textarea disabled style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} value={state.bestFeature_ar} type="text" id="form36" name="bestFeature_ar" class="form-control" />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div class="md-form">
                                            <label htmlFor="form15" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishAddress}</label>
                                            <br></br>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            <textarea disabled style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} value={state.address_en} type="text" id="form15" name="address_en" class="form-control" />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div class="md-form">
                                            <label htmlFor="form26" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicAddress}</label>
                                            <br></br>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            <textarea disabled style={{ border: 'none', borderBottom: '1px solid #dededede', direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} value={state.address_ar} type="text" id="form26" name="address_ar" class="form-control" />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form562" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.size}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.size} min={0} type="number" id="form562" name="size" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form569" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.price}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="number" min={1} value={state.price} id="form569" name="price" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form009" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.deposit}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" value={state.deposit ? state.deposit : allStrings.no} id="form009" name="deposit" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form009" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.advertiserClass}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" value={state.advertiserClass === "OWNER" ? allStrings.owner : allStrings.commissioner} id="form009" name="advertiserClass" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form119" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.commissionNumber}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" value={state.commissionNumber ? state.commissionNumber : allStrings.no} id="form119" name="commissionNumber" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form119" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.company}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" value={state.company} id="form119" name="company" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form402" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.subCategory}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.subCategory} type="text" id="form402" name="subCategory" class="form-control" required validate />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form409" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.category}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" value={state.category} id="form409" name="category" class="form-control" required validate />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form402" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.area}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.area} type="text" id="form402" name="area" class="form-control" required validate />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form409" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.city}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" value={state.city} id="form409" name="city" class="form-control" required validate />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form6015" className="customLabel" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.date}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={moment(state.createdAt).format('MMMM Do YYYY, h:mm a')} type="text" id="form6015" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                            <label htmlFor="form6015" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.views}</label>
                                            <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.viewsCount} type="text" id="form6015" class="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>

                                {state.depositPaidUser &&
                                    <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                                        <MDBCol md="10" xs="10">
                                            <div class="md-form">
                                                <label htmlFor="form80" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.depositPaidUser}</label>
                                                <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.owner ? state.owner.fullname : ''} type="text" id="form80" class="form-control" />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="2" xs="2">

                                            <p style={{ textAlign: 'center', marginTop: '2.3rem', color: '#2BBBAD' }}>
                                                <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                                    onClick={() => { history.push('userInfo', { data: state.depositPaidUser }) }}>
                                                    remove_red_eye
                                                </span>
                                                <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                                    onClick={() => { history.push('userInfo', { data: state.depositPaidUser }) }}>
                                                    {allStrings.show}
                                                </span>
                                            </p>
                                        </MDBCol>
                                    </MDBRow>
                                }
                                {state.paymentPlan &&
                                    <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                                        <MDBCol md="10" xs="10">
                                            <div class="md-form">
                                                <label htmlFor="form80" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.paymentPlan}</label>
                                                <input disabled style={{ direction: isRTL ? 'rtl' : 'ltr', backgroundPosition: isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={state.paymentPlan ? state.paymentPlan.name : ''} type="text" id="form80" class="form-control" />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="2" xs="2">

                                            <p style={{ textAlign: 'center', marginTop: '2.3rem', color: '#2BBBAD' }}>
                                                <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                                    onClick={() => { history.push('paymentPlanInfo', { data: state.paymentPlan }) }}>
                                                    remove_red_eye
                                                </span>
                                                <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                                    onClick={() => { history.push('paymentPlanInfo', { data: state.paymentPlan }) }}>
                                                    {allStrings.show}
                                                </span>
                                            </p>
                                        </MDBCol>
                                    </MDBRow>
                                }
                                <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                                    <label className="labelBox" style={{ textAlign: isRTL ? 'right' : 'left' }}>
                                        <span>{allStrings.subFeatures}</span>
                                    </label>
                                    {state.features.length > 0 ?
                                        state.features.map((val, index) =>
                                            <MDBCol md='2' style={{ textAlign: 'center' }}>
                                                <img src={val.img} style={{ width: '50px' }} alt="" />
                                                <p style={{ textAlign: 'center', width: '100%' }}>{val.name}</p>
                                            </MDBCol>
                                        )
                                        :
                                        <MDBCol md="12">
                                            <Empty description={allStrings.noData} style={{ margin: '0rem' }} />
                                        </MDBCol>
                                    }
                                </MDBRow>
                                <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                                    <label className="labelBox" style={{ textAlign: isRTL ? 'right' : 'left' }}>
                                        <span>{allStrings.mainFeatures}</span>
                                    </label>
                                    {state.properties.length > 0 ?
                                        state.properties.map((val, index) =>
                                            val.type !== "LIST" ?
                                                <MDBCol md='2' style={{ textAlign: 'center' }}>
                                                    <img src={val.img} style={{ width: '50px' }} alt="" />
                                                    <p style={{ textAlign: 'center', width: '100%', marginBottom: '4px' }}>{val.name}</p>
                                                    <p style={{ textAlign: 'center', width: '100%' }}>{val.value}</p>
                                                </MDBCol>
                                                :
                                                <MDBCol md='2' style={{ textAlign: 'center' }}>
                                                    <img src={val.img} style={{ width: '50px' }} alt="" />
                                                    <p style={{ textAlign: 'center', width: '100%', marginBottom: '4px' }}>{val.name}</p>
                                                    <p style={{ textAlign: 'center', width: '100%' }}>{val.value}</p>
                                                </MDBCol>
                                        )
                                        :
                                        <MDBCol md="12">
                                            <Empty description={allStrings.noData} style={{ margin: '0rem' }} />
                                        </MDBCol>
                                    }
                                </MDBRow>
                                {state.categoryType === "PLANNED" &&

                                    <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                                        <label className="labelBox" style={{ textAlign: isRTL ? 'right' : 'left' }}>
                                            <span>{allStrings.lands}</span>
                                        </label>
                                        {state.lands.length > 0 ?
                                            state.lands.map((val, index) =>
                                                <MDBCol md="2" style={{ marginBottom: '10px' }}>
                                                    <Tooltip title={val.status == "BOOKED" ? allStrings.booked : val.status == "SOLD" ? allStrings.sold : val.status == "COMPLETED" ? allStrings.completedUnit : val.status == "BOOKED-WITHOUT-PAY" ? allStrings.bookedWithoutPay : val.status == "DELIVERED" ? allStrings.deliverd : allStrings.available} placement="top">
                                                        <div
                                                            onClick={() => { setNewData(val.id) }}
                                                            style={{
                                                                background:
                                                                    val.status == "BOOKED" ? 'linear-gradient(135deg, #f7781eff, #FC575E)' :
                                                                        val.status == "BOOKED-WITHOUT-PAY" ? 'linear-gradient(135deg, #F7B42C, #F7971E)' :
                                                                            val.status == "SOLD" ? 'linear-gradient(135deg, #FF3547, #B71C1C)' :
                                                                                val.status == "COMPLETED" ? 'linear-gradient(135deg, #5A3286, #8235d3ff)' :
                                                                                    val.status == "DELIVERED" ? 'linear-gradient(135deg, #4285F4, #3367D6)' :
                                                                                        'linear-gradient(135deg, #1dd933ff, #0cab46ff)', color: '#fff', padding: '4px', cursor: 'pointer', fontWeight: '400'
                                                            }}>
                                                            <p style={{ textAlign: 'center', width: '100%', marginBottom: '4px' }}>{val.title}</p>
                                                        </div>
                                                    </Tooltip>
                                                </MDBCol>

                                            )
                                            :
                                            <MDBCol md="12">
                                                <Empty description={allStrings.noData} style={{ margin: '0rem' }} />
                                            </MDBCol>
                                        }
                                    </MDBRow>
                                }
                                {state.categoryType === "VILLAS" &&
                                    <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                                        <label className="labelBox" style={{ textAlign: isRTL ? 'right' : 'left' }}>
                                            <span>{allStrings.villas}</span>
                                        </label>
                                        {state.villas.length > 0 ?
                                            state.villas.map((val, index) =>
                                                <MDBCol md="2" style={{ marginBottom: '10px' }}>
                                                    <Tooltip title={val.status == "BOOKED" ? allStrings.booked : val.status == "SOLD" ? allStrings.sold : val.status == "COMPLETED" ? allStrings.completedUnit : val.status == "BOOKED-WITHOUT-PAY" ? allStrings.bookedWithoutPay : val.status == "DELIVERED" ? allStrings.deliverd : allStrings.available} placement="top">
                                                        <div
                                                            onClick={() => { setNewData(val.id) }}
                                                            style={{
                                                                background:
                                                                    val.status == "BOOKED" ? 'linear-gradient(135deg, #f7781eff, #FC575E)' :
                                                                        val.status == "BOOKED-WITHOUT-PAY" ? 'linear-gradient(135deg, #F7B42C, #F7971E)' :
                                                                            val.status == "SOLD" ? 'linear-gradient(135deg, #FF3547, #B71C1C)' :
                                                                                val.status == "COMPLETED" ? 'linear-gradient(135deg, #5A3286, #8235d3ff)' :
                                                                                    val.status == "DELIVERED" ? 'linear-gradient(135deg, #4285F4, #3367D6)' :
                                                                                        'linear-gradient(135deg, #1dd933ff, #0cab46ff)', color: '#fff', padding: '4px', cursor: 'pointer', fontWeight: '400'
                                                            }}>
                                                            <p style={{ textAlign: 'center', width: '100%', marginBottom: '4px' }}>{val.title}</p>
                                                        </div>
                                                    </Tooltip>
                                                </MDBCol>

                                            )
                                            :
                                            <MDBCol md="12">
                                                <Empty description={allStrings.noData} style={{ margin: '0rem' }} />
                                            </MDBCol>
                                        }
                                    </MDBRow>
                                }
                                {state.categoryType === "OFF-PLAN-SALE" &&
                                    <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                                        <label className="labelBox" style={{ textAlign: isRTL ? 'right' : 'left' }}>
                                            <span>{allStrings.buildings}</span>
                                        </label>
                                        {state.buildings.length > 0 ?
                                            state.buildings.map((val, index) =>
                                                <MDBCol md="2" style={{ marginBottom: '10px' }}>
                                                    <div
                                                        onClick={() => { setNewData(val.id) }}
                                                        style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff', padding: '4px', cursor: 'pointer', fontWeight: '400' }}>
                                                        <p style={{ textAlign: 'center', width: '100%', marginBottom: '4px' }}>{val.title}</p>
                                                    </div>
                                                </MDBCol>
                                            )
                                            :
                                            <MDBCol md="12">
                                                <Empty description={allStrings.noData} style={{ margin: '0rem' }} />
                                            </MDBCol>
                                        }
                                    </MDBRow>
                                }
                                {state.categoryType === "BUILDING" &&
                                    <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                                        <label className="labelBox" style={{ textAlign: isRTL ? 'right' : 'left' }}>
                                            <span>{allStrings.units}</span>
                                        </label>
                                        {state.units.length > 0 ?
                                            state.units.map((val, index) =>
                                                <MDBRow style={{ flexDirection: isRTL ? 'row-reverse' : 'row', width: '100%', padding: '14px' }}>
                                                    <label htmlFor="form830" style={{ textAlign: isRTL ? 'right' : 'left', width: '100%', margin: '15px' }}>
                                                        {isRTL ?
                                                            <span>{val.floor + " " + allStrings.floorNumber}</span>
                                                            :
                                                            <span>{" " + allStrings.floorNumber + " " + val.floor}</span>
                                                        }

                                                    </label>

                                                    {val.unit.map((i, index) =>
                                                        <MDBCol md="2" style={{ marginBottom: '10px' }}>
                                                            <Tooltip title={i.status == "BOOKED" ? allStrings.booked : i.status == "SOLD" ? allStrings.sold : i.status == "COMPLETED" ? allStrings.completedUnit : i.status == "BOOKED-WITHOUT-PAY" ? allStrings.bookedWithoutPay : i.status == "DELIVERED" ? allStrings.deliverd : allStrings.available} placement="top">
                                                                <div
                                                                    onClick={() => { setNewData(i.id) }}
                                                                    style={{
                                                                        background:
                                                                            i.status == "BOOKED" ? 'linear-gradient(135deg, #f7781eff, #FC575E)' :
                                                                                i.status == "BOOKED-WITHOUT-PAY" ? 'linear-gradient(135deg, #F7B42C, #F7971E)' :
                                                                                    i.status == "SOLD" ? 'linear-gradient(135deg, #FF3547, #B71C1C)' :
                                                                                        i.status == "COMPLETED" ? 'linear-gradient(135deg, #5A3286, #8235d3ff)' :
                                                                                            i.status == "DELIVERED" ? 'linear-gradient(135deg, #4285F4, #3367D6)' :
                                                                                                'linear-gradient(135deg, #1dd933ff, #0cab46ff)', color: '#fff', padding: '4px', cursor: 'pointer', fontWeight: '400'
                                                                    }}>
                                                                    <p style={{ textAlign: 'center', width: '100%', marginBottom: '4px' }}>{i.title}</p>
                                                                </div>
                                                            </Tooltip>
                                                        </MDBCol>

                                                    )}
                                                </MDBRow>
                                            ) :
                                            <MDBCol md="12">
                                                <Empty description={allStrings.noData} style={{ margin: '0rem' }} />
                                            </MDBCol>
                                        }
                                    </MDBRow>
                                }
                            </div>
                        </form>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </CardContent>
    );
}
// Component for the Suggested clients table
export const SuggestedClientsTable = ({ allStrings, state, isRTL, history, getSuggestedClients, setPage }) => {
    return (
        <MDBRow>
            <MDBCol md="12">
                <div className="infoTable">
                    <div className="topInfoTable" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}>
                        <h4>
                            {allStrings.SuggestedClients}
                        </h4>
                    </div>
                    <div className="tableDate">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    {isRTL ?
                                        <tr style={{ textAlign: 'center' }}>
                                            <th>{allStrings.more}</th>
                                            <th>{allStrings.clientType}</th>
                                            <th>{allStrings.clientStatus}</th>
                                            <th>{allStrings.phone}</th>
                                            <th>{allStrings.client}</th>
                                            <th scope="col">#</th>
                                        </tr>
                                        :
                                        <tr style={{ textAlign: 'center' }}>
                                            <th scope="col">#</th>
                                            <th>{allStrings.client}</th>
                                            <th>{allStrings.phone}</th>
                                            <th>{allStrings.clientStatus}</th>
                                            <th>{allStrings.clientType}</th>
                                            <th>{allStrings.more}</th>
                                        </tr>
                                    }
                                </thead>
                                <tbody>
                                    {state.loading ?
                                        <tr style={{ height: '200px' }}>
                                            <th colSpan="6" className="noData">
                                                <Skeleton height={400} />
                                            </th>
                                        </tr>
                                        :
                                        state.suggestedClients.length > 0 ?
                                            state.suggestedClients.map(val => (
                                                isRTL ?
                                                    <tr style={{ textAlign: 'center' }} key={val.id}>
                                                        <td>
                                                            <span
                                                                style={{ margin: "4px", cursor: 'pointer' }}
                                                                onClick={() => { history.push("requestInfo", { data: val }) }}
                                                            >
                                                                <Tooltip title={allStrings.info} placement="top">
                                                                    <Info style={{ color: '#33d633' }} />
                                                                </Tooltip>
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span style={{ padding: '0px 20px 3px' }} className='tag'>
                                                                {val.clientType === "RENT" ? allStrings.rent : val.clientType === "INVESTMENT" ? allStrings.investment : val.clientType === "HOUSING" ? allStrings.housing : val.clientType === "OFF-PLAN-SALE" ? allStrings.offPlanSale : 'غير معلوم'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span style={{ padding: '0px 20px 3px' }} className='tag'>
                                                                {val.clientStatus === "PURCHASED-IN-ANOTHER-PROJECT" ? allStrings.purchasedAnotherProject :
                                                                    val.clientStatus === "INTEREST-IN-ANOTHER-OFFER" ? allStrings.interestInAnotherOffer :
                                                                        val.clientStatus === "NOT-INTERESTED" ? allStrings.notInterested :
                                                                            val.clientStatus === "PURCHASED" ? allStrings.purchased : 'غير معلوم'}
                                                            </span>
                                                        </td>
                                                        <td>{val.phone}</td>
                                                        <td>{val.fullname}</td>
                                                        <td>{val.id}</td>
                                                    </tr>
                                                    :
                                                    <tr style={{ textAlign: 'center' }} key={val.id}>
                                                        <td>{val.id}</td>
                                                        <td>{val.fullname}</td>
                                                        <td>{val.phone}</td>
                                                        <td>
                                                            <span style={{ padding: '0px 20px 3px' }} className='tag'>
                                                                {val.clientStatus === "PURCHASED-IN-ANOTHER-PROJECT" ? allStrings.purchasedAnotherProject :
                                                                    val.clientStatus === "INTEREST-IN-ANOTHER-OFFER" ? allStrings.interestInAnotherOffer :
                                                                        val.clientStatus === "NOT-INTERESTED" ? allStrings.notInterested :
                                                                            val.clientStatus === "PURCHASED" ? allStrings.purchased : 'غير معلوم'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span style={{ padding: '0px 20px 3px' }} className='tag'>
                                                                {val.clientType === "RENT" ? allStrings.rent : val.clientType === "INVESTMENT" ? allStrings.investment : val.clientType === "HOUSING" ? allStrings.housing : val.clientType === "OFF-PLAN-SALE" ? allStrings.offPlanSale : 'غير معلوم'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span
                                                                style={{ margin: "4px", cursor: 'pointer' }}
                                                                onClick={() => { history.push("requestInfo", { data: val }) }}
                                                            >
                                                                <Tooltip title={allStrings.info} placement="top">
                                                                    <Info style={{ color: '#33d633' }} />
                                                                </Tooltip>
                                                            </span>
                                                        </td>
                                                    </tr>
                                            ))
                                            :
                                            <tr style={{ height: '200px' }}>
                                                <th colSpan="6" className="noData">
                                                    <Empty description={allStrings.noData} style={{ margin: '0rem' }} />
                                                </th>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                            {state.suggestedClients.length > 0 &&
                                <div style={{ textAlign: 'center', margin: 'auto', marginTop: '3rem' }}>
                                    <PaginationButtons
                                        page={state.page2}
                                        pages={state.pages2}
                                        labels={allStrings}
                                        onPageChange={(newPage) => {
                                            getSuggestedClients(newPage, state.id);
                                            setPage(newPage);
                                        }}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </MDBCol>
        </MDBRow>
    );
};